import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { setCurrentStep } from 'src/store/slices/onboardingSlice';
import OnboardingStep0 from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep0/OnboardingStep0';
import OnboardingStep1 from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep1/OnboardingStep1';
import OnboardingStep2 from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/OnboardingStep2';
import { OnboardingStep3 } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep3/OnboardingStep3';
import { OnboardingStep4 } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep4/OnboardingStep4';
import OnboardingStep5 from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep5/OnboardingStep5';
import OnboardingStep6 from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep6/OnboardingStep6';
import OnboardingStep7 from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep7/OnboardingStep7';
import { usePreventBack } from 'src/hooks/usePreventBack';
import { useAppDispatch } from 'src/store';

const OnboardingSteps = () => {
  const { step } = useParams();
  const currentStep = (step && +step) || 0;
  const dispatch = useAppDispatch();
  let component;

  useEffect(() => {
    dispatch(setCurrentStep(currentStep));
  }, [step]);

  usePreventBack();

  switch (currentStep) {
    case 0:
      component = <OnboardingStep0 />;
      break;
    case 1:
      component = <OnboardingStep1 />;
      break;
    case 2:
      component = <OnboardingStep2 />;
      break;
    case 3:
      component = <OnboardingStep3 />;
      break;
    case 4:
      component = <OnboardingStep4 />;
      break;
    case 5:
      component = <OnboardingStep5 />;
      break;
    case 6:
      component = <OnboardingStep6 />;
      break;
    case 7:
      component = <OnboardingStep7 />;
      break;
  }

  return component;
};

export default OnboardingSteps;
